import { TopBar } from "../components/TopBar";
import { Hero } from "../components/Hero";
import { StartCard } from "../components/StartCard";
import { HowWeWork } from "../components/HowWeWork";
import { SiteFooter } from "../components/SiteFooter";

export default function Gate() {
  return (
    <>
      <TopBar hidePrivate />
      <main className="evc-landing" data-testid="evc-gate">
        <div className="evc-landing-hero">
          <Hero />
        </div>
        <StartCard />
        <HowWeWork />
      </main>
      <SiteFooter />
    </>
  );
}
